import { HOST, } from "common/constants";
import React, { useEffect, useState } from "react";
import axios from "axios";

// import styles from scss
import classes from "./vacancy.module.scss";

/// MUI components;
import { Box, Container } from "@mui/material";

/// import custom components;
import { HTag } from "components/HTag";
import AccordionComponent from "components/UI/Accordion/AccordionComponent";
import Empty from "components/Empty/Empty";
import PaginationComponent from "components/UI/Pagination/PaginationComponent";

import { useTranslation } from "react-i18next";

const Vacancy = () => {
  const { t } = useTranslation();

  const [vacancies, setVacancies] = useState([]);
  const [count, setCount] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [page, setPage] = useState(1);

  const offset = 9;
  const lengthItems = Math.ceil(count / offset);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    const fetchVacancies = async () => {
      try {
        const res = await axios.get(`${HOST}/api/v1/vacancies/`, {
          params: { limit: offset, offset: (page - 1) * offset },
        });
        setVacancies(res.data.results || []);
        setCount(res.data.count || 0);
      } catch (err) {
        console.error("Ошибка при загрузке вакансий:", err);
      }
    };

    fetchVacancies();
  }, [page]);

  return (
    <Box className={classes.mainVacancy}>
      <Container>
        <HTag tag={"h2"}>
          {t("vacancy")}
        </HTag>
        <Box sx={{ maxWidth: "1135px", margin: "0 auto" }}>
          {count > 0 ? (
            vacancies.map((acc) => (
              <AccordionComponent
                key={acc.id}
                title={acc.title}
                description={acc.description}
                id={acc.id}
                handleChange={handleChange}
                expanded={expanded}
              />
            ))
          ) : (
            <Empty />
          )}

          <PaginationComponent
            page={page}
            setPage={setPage}
            length={lengthItems}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Vacancy;
